import React from "react";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';

const Pagination = ({ pagination }) => {
    const handlePageChange = () => {
        window.scrollTo(0, 0);
    };

    return (
        <Stack
            spacing={2}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ py: 5 }}
        >
            {pagination?.prev && (
            <Button
                component={Link}
                variant="outlined"
                size="large"
                sx={{ color: "#777", borderColor: "#777" }}
                startIcon={<ArrowBackIcon />}
                to={pagination?.prev?.link}
                onClick={handlePageChange} 
            >
                {pagination?.prev?.name}
            </Button>
            )}
            {pagination?.next && (
                <Button
                    component={Link}
                    variant="outlined"
                    size="large"
                    sx={{ color: "#777", borderColor: "#777" }}
                    endIcon={<ArrowForwardIcon />}
                    to={pagination.next.link}
                    onClick={handlePageChange} 
                >
                    {pagination.next.name}
                </Button>
            )}

        </Stack>
    );
};

export default Pagination;